import { render } from "./RadioCheck.vue?vue&type=template&id=fdf86ca2&scoped=true"
const script = {}

import "./RadioCheck.vue?vue&type=style&index=0&id=fdf86ca2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdf86ca2"]])

export default __exports__